import { SortDescriptor } from "@filament/react/types";

export interface SortProps<T> {
    items: readonly T[];
    sortDescriptor?: SortDescriptor
}

export function sort<T>({ items, sortDescriptor }: SortProps<T>) {
    if (!sortDescriptor?.column) return [...items];
    const { column, direction } = sortDescriptor;

    return [...items].sort((a, b) => {
        const first = a[column as keyof T];
        const second = b[column as keyof T];
        const cmp = compare(first, second);
        
        return direction === 'descending' ? -cmp : cmp;
    });
};

function compareNulls(a: unknown, b: unknown): number | null {
    if (a == null && b == null) return 0;
    if (a == null) return 1;
    if (b == null) return -1;
    return null;
}

function compareTyped(a: NonNullable<unknown>, b: NonNullable<unknown>): number | null {
    if (typeof a === 'number' && typeof b === 'number') return a - b;
    if (a instanceof Date && b instanceof Date) return a.getTime() - b.getTime();
    const numA = Number(a);
    const numB = Number(b);
    if (!Number.isNaN(numA) && !Number.isNaN(numB)) return numA - numB;
    return null;
}

function compare(a: unknown, b: unknown): number {
    const nullResult = compareNulls(a, b);
    if (nullResult !== null) return nullResult;
    return compareTyped(a!, b!) ?? String(a).localeCompare(String(b), undefined, { numeric: true, sensitivity: 'base' });
}